export default __webpack_public_path__ + "static/media/Logo.097ad814.svg";